import http from '../api/api'
import config from '../api/constants'

const linkAccountVerify = async (reqParams) => {
  try {
    const params = {
      requestId: 'ACCOUNTLINKVERIFY',
      ...reqParams
    }
    const response = await http.post(config.apiRoute.LINK_ACCOUNT_VERIFY, params)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const linkAccountConfirm = async (reqParams) => {
  try {
    const params = {
      requestId: 'ACCOUNTLINKCONFIRM',
      ...reqParams
    }
    const response = await http.post(config.apiRoute.LINK_ACCOUNT, params)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const LinkAccountService = {
  linkAccountVerify,
  linkAccountConfirm
}

export default LinkAccountService